import module from 'finanzas/module.js'
import template from './template.html'
import { orderBy } from 'lodash'
import * as moment from 'moment'

export class FinancesServiciosagregadosListaComponent {
  data
  fechaInicial
  fechaFinal
  resultados
  resultadosAgrupados
  filtros = {
    q: '',
    moneda: '1',
    naturaleza: 'C',
    agrupacion: 'Captura_Usuario_Nombre',
  }
  catalogos = {
    agrupacion: [
      {id: 'Captura_Usuario_Nombre', descripcion: 'Usuario que capturó'},
      {id: 'Empresa', descripcion: 'Empresa'},
      {id: 'Periodo', descripcion: 'Período'},
      {id: 'Concepto', descripcion: 'Concepto'},
    ],
    moneda: [
      {id: '1', descripcion: 'MXN'},
      {id: '2', descripcion: 'USD'},
    ],
    naturaleza: [
      {id: 'C', descripcion: 'Cargo'},
      {id: 'A', descripcion: 'Abono'},
    ],
  }
  exportando = false

  constructor ($filter) {
    this.filterBy = $filter('filter')
  }

  $onChanges (changes) {
    if (changes.data) {
      if (!Array.isArray(this.data)) this.data = []
      this.data = this.data
        .map((item) => {
          item.Periodo = moment(item.Fecha_Movimiento).format('MMMM YYYY').toUpperCase()

          return item
        })

      this.filtrar()
    }
  }

  actualizar (item, data) {
    Object.assign(item, data)
    this.filtrar()
  }

  filtrar () {
    if (!this.data) return

    this.resultados = this.filterBy(this.data, this.filtros.q)
      .filter((item) => item.Naturaleza === this.filtros.naturaleza && item.Tipo_Moneda === this.filtros.moneda)

    let grupos = this.resultados.reduce((grupos, item) => {
      let grupo = item[this.filtros.agrupacion]
      if (!grupos[grupo]) {
        grupos[grupo] = {
          id: item[this.filtros.agrupacion],
          label: item[this.filtros.agrupacion],
          isOpen: true,
          total: 0,
          data: [],
        }
      }

      grupos[grupo].data.push(item)
      grupos[grupo].total = Number((grupos[grupo].total + item['Importe']).toFixed(2))

      return grupos
    }, {})

    this.resultadosAgrupados = orderBy(Object.values(grupos), ['label'])
  }
}

module.component('financesServiciosagregadosLista', {
  controller: FinancesServiciosagregadosListaComponent,
  template,
  bindings: {
    data: '<',
    fechaInicial: '<',
    fechaFinal: '<',
  },
})



// WEBPACK FOOTER //
// ./src/finanzas/components/serviciosagregados/lista/component.js